import cn from 'classnames';
import { EngineTheme } from '@websky/core/src/theme';
import BaseButtons from './components/BaseComponents/Button/Button.css';
import Stepbar from './components/Stepbar/components/Stepbar.css';
import Counter from './components/Counter/Counter.css';
import PassengerSwitch from './components/Passenger/components/Field/Switch/Switch.css';
import Input from './components/Input/Input.css';
import Select from './components/Passenger/components/Field/Select/Select.css';
import Meal from './components/Meal/Meal.css';
import Checkout from './components/Checkout/Checkout.css';
import MealServiceList from './components/MealService/components/List/List.css';
import SearchForm from './components/SearchForm/SearchForm.css';
import SearchFormSegments from './components/SearchForm/Segments/Segments.css';
import SearchFormSegment from './components/SearchForm/Segment/Segment.css';
import SearchFormControls from './components/SearchForm/Controls/Controls.css';
import SearchFormMultiCity from './components/SearchForm/MultiCity/MultiCity.css';
import SearchFormPassengers from './components/SearchForm/Passengers/Passengers.css';
import SearchFormStartSearch from './components/SearchForm/StartSearch/StartSearch.css';
import SearchFormDatepicker from './components/SearchForm/Datepicker/Datepicker.css';
import SearchFormLocation from './components/SearchForm/Location/Location.css';
import SearchFormBottom from './components/SearchForm/Bottom/Bottom.css';
import SearchFormActions from './components/SearchForm/Actions/Actions.css';
import SearchFormValue from './components/SearchForm/Value/Value.css';
import SearchFormDatepickerStyles from './components/SearchFormDatepicker/SearchFormDatepicker.css';
import SearchFormDatepickerMonthHeader from './components/SearchFormDatepicker/MonthHeader/MonthHeader.css';
import SearchFormDatepickerWeeklyHeader from './components/SearchFormDatepicker/WeeklyHeader/WeeklyHeader.css';
import SearchFormDatepickerDay from './components/SearchFormDatepicker/Day/Day.css';
import SearchFormDatePickerMonthsWrapper from './components/SearchFormDatepicker/MonthsWrapper/MonthsWrapper.css';
import LocationAutocomplete from './components/LocationAutocomplete/LocationAutocomplete.css';
import DirectionsDialog from './components/LocationAutocomplete/DirectionsDialog/DirectionsDialog.css';
import Results from './components/Results/Results.css';
import ResultsCalendar from './components/Results/Calendar/Calendar.css';
import ResultsSortings from './components/Results/Sortings/Sortings.css';
import ResultsFlightsList from './components/Results/FlightsList/FlightsList.css';
import ResultsSelectedFares from './components/Results/SelectedFares/SelectedFares.css';
import DesktopFlightRoute from './components/DesktopFlightRoute/DesktopFlightRoute.css';
import DesktopFlightRoutePrice from './components/DesktopFlightRoute/FlightPrice/FlightPrice.css';
import DesktopFlightRoutePoint from './components/DesktopFlightRoute/Point/Point.css';
import DesktopFlightRouteArrow from './components/DesktopFlightRoute/RouteArrow/RouteArrow.css';
import DesktopFlightRouteSegment from './components/DesktopFlightRoute/Segment/Segment.css';
import DesktopFlightRouteStopsInfo from './components/DesktopFlightRoute/StopsInfo/StopsInfo.css';
import DesktopFlightModalContent from './components/DesktopFlight/ModalContent/ModalContent.css';
import DesktopFlightInfoSegment from './components/DesktopFlight/FlightInfoSegment/FlightInfoSegment.css';
import DesktopFlightLocation from './components/DesktopFlight/Location/Location.css';
import DesktopFlightModalHeader from './components/DesktopFlight/DesktopFlightModalHeader/DesktopFlightModalHeader.css';
import DesktopFlightSelectedFareGroup from './components/DesktopFlight/SelectedFareGroup/SelectedFareGroup.css';
import FlightCard from './components/FlightCard/FlightCard.css';
import CompareFares from './components/CompareFares/CompareFares.css';
import TransferInfo from './components/TransferInfo/TransferInfo.css';
import FareLockDescription from './components/FareLock/DescriptionBlock/DescriptionBlock.css';
import MobileSegmentInfo from './components/MobileSegmentInfo/MobileSegmentInfo.css';
import AircraftPopup from './components/AircraftPopup/AircraftPopup.css';
import MobileFlight from './components/MobileFlight/MobileFlight.css';
import Passengers from './components/Passengers/Passengers.css';
import SeatMapPassenger from './components/SeatMap/components/Passengers/Passenger/Passenger.css';
import SeatMapPassengers from './components/SeatMap/components/Passengers/Passengers.css';
import SeatMapComponent from './components/SeatMap/components/Component.css';
import SeatMap from './components/SeatMap/components/SeatMap/SeatMap.css';
import SeatMapAirplane from './components/SeatMap/components/Airplane/Airplane.css';
import SeatMapDisclaimer from './components/SeatMap/components/SeatMapDisclaimer/SeatMapDisclaimer.css';
import SeatsInfo from './components/SeatMap/components/SeatsInfo/SeatsInfo.css';
import SeatTooltip from './components/SeatMap/components/SeatMap/Seat/SeatTooltip/SeatTooltip.css';
import DoubleSeat from './components/SeatMap/components/Passengers/DoubleSeat/DoubleSeat.css';
import Seat from './components/SeatMap/components/Seat/Seat.css';
import Amenities from './components/Amenities/Amenities.css';
import AdditionalServiceBanner from './components/AdditionalServiceBanner/AdditionalServiceBanner.css';
import BaggagePage from './components/BaggagePage/BaggagePage.css';
import Checkin from './components/Checkin/Checkin.css';
import PromoLoader from './components/PromoLoader/PromoLoader.css';
import ExchangeInner from './components/Modules/Exchange/components/Exchange/Inner/Inner.css';
import ExchangeCommonSelect from './components/Modules/Exchange/components/Exchange/CommonSelect/CommonSelect.css';
import ExchangeChoice from './components/Modules/Exchange/components/Exchange/Choice/Choice.css';
import ExchangeChip from './components/Modules/Exchange/components/Exchange/Inner/Selections/Chip/Chip.css';
import ExchangeSearchFlights from './components/Modules/Exchange/components/Exchange/SearchFlights/SearchFlights.css';
import ExchangeSelectedFlights from './components/Modules/Exchange/components/Exchange/Request/SelectedFlights/SelectedFlights.css';
import ExchangeCreateRequest from './components/Modules/Exchange/components/Exchange/CreateRequest/CreateRequest.css';
import ExchangeRequestControls from './components/Modules/Exchange/components/Exchange/RequestForm/RequestControls/RequestControls.css';
import RefundBreadcrumbs from './components/Refund/Components/Breadcrumbs/Breadcrumbs.css';
import RefundWrapper from './components/Refund/Components/Wrapper/Wrapper.css';
import RefundStepTitle from './components/Refund/Components/StepTitle/StepTitle.css';
import RefundReasonForm from './components/Refund/Components/ReasonForm/ReasonForm.css';
import RefundStepsButtons from './components/Refund/Components/StepsButtons/StepsButtons.css';
import RefundStatus from './components/Refund/Components/Status/Status.css';
import RefundPrice from './components/Refund/Components/Price/Price.css';
import RefundInfoModal from './components/Refund/Components/RefundInfoModal/RefundInfoModal.css';
import DesktopSummaryFlight from './components/DesktopSummaryFlight/DesktopSummaryFlight.css';
import MobileStepbar from './components/MobileStepbar/components/MobileStepbar.css';
import MobileStepbarHeader from './components/MobileStepbar/components/StepbarHeader/StepbarHeader.css';
import Link from './components/BaseComponents/Link/Link.css';
import Modal from './components/Modal/Modal.css';
import Toolbar from './components/Toolbar/Toolbar.css';
import PaymentForm from './components/PaymentForm/components/PaymentForm.css';
import InsuranceUpsale from './components/CheckoutAdditionalService/components/InsuranceUpsale/InsuranceUpsale.css';
import TaxesTooltip from './components/TaxesTooltip/TaxesTooltip.css';
import Checkbox from './components/Checkbox/Checkbox.css';

const theme: EngineTheme = {
	PromoLoader: {
		PromoLoader: {
			promo: PromoLoader.promo,
			promo__image: PromoLoader.promo__image
		}
	},
	CheckoutAdditionalService: {
		InsuranceUpsale: {
			oldVersion: InsuranceUpsale.oldVersion,
			change: InsuranceUpsale.change
		}
	},
	Passenger: {
		PassengerSwitch: {
			container: PassengerSwitch.container,
			element: PassengerSwitch.element,
			element_active: PassengerSwitch.element_active,
			element_error: PassengerSwitch.element_error
		},
		Select: {
			label: Select.label,
			helperText: Select.helperText
		}
	},
	Input: {
		Input: {
			root: Input.boxLabelIn,
			label_shrink: Input.label_shrink,
			input: Input.input,
			input_filled: Input.input_filled,
			real_input: Input.real_input,
			underline: Input.underline
		}
	},
	AgreementCheckboxWrapper: {
		AgreementCheckbox: {
			checkbox: Checkbox.checkbox
		}
	},
	Link: {
		Link: {
			link: Link.link
		}
	},
	Modal: {
		Modal: {
			closeIcon: Modal.closeIcon
		}
	},
	Counter: {
		Counter: {
			counter: Counter.counter,
			button: Counter.button,
			button_disabled: Counter.button_disabled
		}
	},
	Stepbar: {
		Stepbar: {
			cart: Stepbar.cart
		}
	},
	BaseComponents: {
		Button: {
			optionEdit: BaseButtons.optionEdit
		}
	},
	Meal: {
		Meal: {
			meal: Meal.meal,
			title: Meal.title,
			price: Meal.price
		}
	},
	Checkout: {
		CheckoutStyles: {
			gdsTotalPrice: Checkout.gdsTotalPrice,
			form: Checkout.form,
			checkoutServices: Checkout.checkoutServices,
			container_seats: Checkout.container_seats
		},
		PassengersToolbar: {
			root: cn(Checkout.passengersToolbar__root, Passengers.toolbarRoot),
			label: Checkout.passengersToolbar__label
		}
	},
	Toolbar: {
		Toolbar: {
			actions: Checkout.toolbar__actions,
			actions_left: Checkout.toolbar__actionsLeft,
			actions_right: Checkout.toolbar__actionsRight,
			price: Checkout.toolbar__price
		}
	},
	CardExtra: {
		CardExtraContent: {
			header__title: Checkout.cardExtra__header__title,
			description: Checkout.cardExtra__description
		}
	},
	OrderCard: {
		CommonItem: { root: Checkout.commonItem__root, icon: Checkout.commonItem__icon },
		PaymentStatus: {
			root: Checkout.paymentStatus__root,
			icon: Checkout.paymentStatus__icon
		},
		OrderStatus: {
			root: Checkout.orderStatus__root,
			icon: Checkout.orderStatus__icon,
			type_review: Checkout.orderStatus__type_review,
			confirmed: Checkout.orderStatus__confirmed
		},
		OrderCard: {
			root: Checkout.orderCard__root,
			container: Checkout.orderCard__container,
			type_review: Checkout.orderCard__type_review
		},
		OrderBooking: {
			root: Checkout.orderBooking__root,
			type_review: Checkout.orderBooking__type_review,
			orderCode: Checkout.orderBooking__orderCode,
			security_code: Checkout.orderBooking__securityCode
		},
		OrderPassengers: {
			control: Checkout.orderPassengers__control
		}
	},
	ServiceSummary: {
		ServiceSummaryOption: {
			wrapper: Checkout.serviceSummary__wrapper,
			option__iconIncluded: Checkout.serviceSummary__option__iconIncluded
		}
	},
	ServiceWithSegments: {
		ServiceWithSegments: {
			service: Checkout.serviceWithSegments__service
		}
	},
	MealService: {
		List: {
			item: MealServiceList.item,
			item_selected: MealServiceList.item_selected,
			item__icon: MealServiceList.item__icon
		}
	},
	SearchForm: {
		AdditionalLinks: {
			link: SearchFormBottom.additionalLinks_link
		},
		SearchForm: {
			searchForm: SearchForm.searchForm,
			searchForm_multiCity: SearchForm.searchForm_multiCity
		},
		Segments: {
			segments: SearchFormSegments.segments,
			segments_multiCity: cn(SearchFormSegments.segments_multiCity, SearchFormSegment.segments_multiCity)
		},
		Segment: {
			wrapper: SearchFormSegment.wrapper,
			segment: SearchFormSegment.segment,
			withMultiCity: SearchFormSegment.withMultiCity,
			cell: SearchFormSegment.cell,
			cell_date: SearchFormSegment.cell_date,
			cell_location: SearchFormSegment.cell_location,
			input: SearchFormSegment.input,
			input_text: SearchFormSegment.input_text,
			input_focused: SearchFormSegment.input_focused,
			alternative: SearchFormSegment.alternative,
			control: SearchFormSegment.control,
			location__value: SearchFormSegment.location__value,
			datepicker_value: SearchFormSegment.datepicker_value
		},
		Controls: {
			controls: SearchFormControls.controls,
			controls_multiCity: SearchFormControls.controls_multiCity
		},
		MultiCity: {
			multiCity: SearchFormMultiCity.multiCity,
			caption: SearchFormMultiCity.caption
		},
		Passengers: {
			passengers: SearchFormPassengers.passengers,
			passengers_isMultiCity: SearchFormPassengers.passengers_isMultiCity,
			menu: SearchFormPassengers.menu,
			selector: SearchFormPassengers.selector,
			title: SearchFormPassengers.title,
			mobileTitle: SearchFormPassengers.mobileTitle,
			alternative: SearchFormPassengers.alternative
		},
		StartSearch: {
			startSearch: SearchFormStartSearch.startSearch,
			startSearch_iconMode: SearchFormStartSearch.startSearch_iconMode,
			startSearch_multiCity: SearchFormStartSearch.startSearch_multiCity
		},
		Datepicker: {
			dates: SearchFormDatepicker.dates,
			dates_focused: SearchFormDatepicker.dates_focused,
			dates__to: SearchFormDatepicker.dates__to,
			dates__back: SearchFormDatepicker.dates__back,
			dates__to_focused: SearchFormDatepicker.dates__to_focused,
			dates__back_focused: SearchFormDatepicker.dates__back_focused,
			dates__to_text: SearchFormDatepicker.dates__to_text,
			dates__icon: SearchFormDatepicker.dates__icon,
			placeholder: SearchFormDatepicker.placeholder,
			date__inputWrapper: SearchFormDatepicker.date__inputWrapper,
			dow: SearchFormDatepicker.dow,
			highlighted_minPrice: SearchFormDatepickerDay.highlighted_minPrice,
			alternative: SearchFormDatepicker.alternative,
			alternative_dow: SearchFormDatepicker.alternative_dow,
			day__price: SearchFormDatepicker.day__price
		},
		Location: {
			switcher: SearchFormLocation.switcher,
			switcher_alternative: SearchFormLocation.switcher_alternative
		},
		Bottom: {
			bottom: SearchFormBottom.bottom,
			controls: SearchFormBottom.controls
		},
		Actions: {
			actions: SearchFormActions.actions,
			addSegment: SearchFormActions.addSegment,
			removeSegment: SearchFormActions.removeSegment
		},
		Value: {
			wrapper_alternative: SearchFormValue.wrapper_alternative,
			value: SearchFormValue.value,
			code: SearchFormValue.code
		},
		PromoCode: {
			promoCode: SearchFormBottom.promoCode
		},
		SearchFormSwitch: {
			label: SearchForm.searchFormSwitch__label
		}
	},
	Passengers: {
		PassengerStyles: {
			decrease: Passengers.decrease,
			increase: Passengers.increase,
			counter: Passengers.counter
		}
	},
	SearchFormDatepicker: {
		SearchFormDatepickerStyles: {
			popup: SearchFormDatepickerStyles.popup,
			dialog__bar: SearchFormDatepickerStyles.dialog__bar,
			dialog__dates: SearchFormDatepickerStyles.dialog__dates,
			dialog__activeDate: SearchFormDatepickerStyles.dialog__activeDate,
			dialog__dateBack: SearchFormDatepickerStyles.dialog__dateBack,
			dialog__close: SearchFormDatepickerStyles.dialog__close,
			footer: SearchFormDatepickerStyles.footer,
			footer__buttons: SearchFormDatepickerStyles.footer__buttons,
			footer__clear: SearchFormDatepickerStyles.footer__clear,
			footer__done: SearchFormDatepickerStyles.footer__done,
			tab__wrapper: SearchFormDatepickerStyles.tab__wrapper,
			tab: SearchFormDatepickerStyles.tab,
			tab_selected: SearchFormDatepickerStyles.tab_selected,
			selectDateHint: SearchFormDatepickerStyles.selectDateHint,
			datepicker__disclaimer: SearchFormDatepickerStyles.datepicker__disclaimer,
			content: SearchFormDatepickerStyles.content
		},
		MonthHeaderStyles: {
			monthHeader: SearchFormDatepickerMonthHeader.monthHeader,
			monthHeader__select_month: SearchFormDatepickerMonthHeader.monthHeader__select_month,
			monthHeader__select_year: SearchFormDatepickerMonthHeader.monthHeader__select_year
		},
		WeeklyHeaderStyles: {
			dayOfWeekName_withPrices: SearchFormDatepickerWeeklyHeader.dayOfWeekName_withPrices
		},
		DayStyles: {
			day: SearchFormDatepickerDay.day,
			day_withPrice: SearchFormDatepickerDay.day_withPrice,
			day_selected: SearchFormDatepickerDay.day_selected,
			day__inside: SearchFormDatepickerDay.day__inside,
			day__price: SearchFormDatepickerDay.day__price,
			day_today: SearchFormDatepickerDay.day_today,
			day_inPeriod: SearchFormDatepickerDay.day_inPeriod,
			day_hasPrice: SearchFormDatepickerDay.day_hasPrice,
			day_weekend: SearchFormDatepickerDay.day_weekend,
			day_startHover_withprice: SearchFormDatepickerDay.day_startHover_withprice,
			day_startHover_withPrice: SearchFormDatepickerDay.day_startHover_withPrice,
			day_endHover_withPrice: SearchFormDatepickerDay.day_endHover_withPrice,
			day_highlighted: SearchFormDatepickerDay.day_highlighted,
			day_startPeriod: SearchFormDatepickerDay.day_startPeriod,
			day_endPeriod: SearchFormDatepickerDay.day_endPeriod
		},
		MonthsWrapperStyles: {
			wrapper: SearchFormDatePickerMonthsWrapper.wrapper,
			monthsList: SearchFormDatePickerMonthsWrapper.monthsList,
			monthsList_withPrice: SearchFormDatePickerMonthsWrapper.monthsList_withPrice,
			nav_next: SearchFormDatePickerMonthsWrapper.nav_next,
			nav_prev: SearchFormDatePickerMonthsWrapper.nav_prev
		},
		MonthStyles: {
			month: SearchFormDatePickerMonthsWrapper.month
		}
	},
	LocationAutocomplete: {
		Autocomplete: {
			autocomplete: LocationAutocomplete.autocomplete
		},
		DirectionsDialog: {
			dialog: DirectionsDialog.dialog,
			cities: DirectionsDialog.cities,
			label: DirectionsDialog.label,
			countries: DirectionsDialog.countries,
			countries__list: DirectionsDialog.countries__list,
			country: DirectionsDialog.country,
			country_active: DirectionsDialog.country_active,
			city: DirectionsDialog.city,
			iata: DirectionsDialog.iata
		}
	},
	PromoCode: {
		PromoCode: {
			promoCode_empty: cn(SearchForm.promoCode_empty),
			promoCode_notApplied: cn(SearchForm.promoCode_notApplied),
			trigger: cn(SearchForm.searchForm__text),
			promoCode_applied: SearchForm.promoCode_applied
		},
		PromoCodeForm: {
			form: SearchForm.promoCodeForm__form,
			statusMessage: SearchForm.promoCodeForm__statusMessage
		}
	},
	QuickSearchForm: {
		QuickSearchForm: {
			form: SearchForm.quickSearchForm
		}
	},
	Results: {
		Results: {
			results: Results.results,
			header: Results.header,
			header__stepbar: Results.header__stepbar,
			inner: Results.inner,
			share: Results.share,
			outer_bottom: Results.outer_bottom,
			toolbar__backButton: Toolbar.toolbar__backButton
		},
		Calendar: {
			header: ResultsCalendar.header,
			legNumber: ResultsCalendar.legNumber,
			title__text: ResultsCalendar.title__text,
			title__cities: ResultsCalendar.title__cities,
			diagram: ResultsCalendar.diagram
		},
		Sortings: {
			title: ResultsSortings.title,
			sortBy: ResultsSortings.sortBy,
			currentSorting: ResultsSortings.currentSorting,
			sortings: ResultsSortings.sortings,
			flightType: ResultsSortings.flightType,
			flightType__active: ResultsSortings.flightType__active,
			listItem: ResultsSortings.listItem,
			listItem_active: ResultsSortings.listItem_active,
			paper: ResultsSortings.paper,
			mobile: ResultsSortings.mobile,
			mobile__list: ResultsSortings.mobile__list,
			mobile__list__title: ResultsSortings.mobile__list__title,
			mobile__list__close: ResultsSortings.mobile__list__close,
			mobile__list__item: ResultsSortings.mobile__list__item,
			mobile__list__button: ResultsSortings.mobile__list__button,
			mobile__list__button_inactive: ResultsSortings.mobile__list__button_inactive,
			mobile__closeButton: ResultsSortings.mobile__closeButton,
			slideBottom: ResultsSortings.slideBottom,
			switchWrp: ResultsSortings.switchWrp
		},
		FlightsList: {
			wrapper: ResultsFlightsList.wrapper,
			controls__wrapper: ResultsFlightsList.controls__wrapper,
			leg: ResultsFlightsList.leg
		},
		SelectedFares: {
			wrapper: ResultsSelectedFares.wrapper
		}
	},
	DesktopFlightRoute: {
		DesktopFlightRouteStyles: {
			flight: cn(DesktopFlightRoute.flight, ExchangeSelectedFlights.flight)
		},
		SegmentStyles: {
			flightInfo__date: DesktopFlightRouteSegment.flightInfo__date,
			flightInfo__airline: DesktopFlightRouteSegment.flightInfo__airline,
			aircraft: DesktopFlightRouteSegment.aircraft,
			segment: DesktopFlightRouteSegment.segment,
			segment_additional: DesktopFlightRouteSegment.segment_additional,
			totalDuration__decorator: DesktopFlightRouteSegment.totalDuration__decorator,
			flightInfo__nextDay: DesktopFlightRouteSegment.flightInfo__nextDay,
			planeInfo: DesktopFlightRouteSegment.planeInfo
		},
		PointStyles: {
			time: DesktopFlightRoutePoint.time,
			airport: DesktopFlightRoutePoint.airport,
			point_thin: DesktopFlightRoutePoint.point_thin,
			date__container: DesktopFlightRoutePoint.date__container
		},
		RouteArrowStyles: {
			timeInRoute: DesktopFlightRouteArrow.timeInRoute
		},
		FlightPriceStyles: {
			price: DesktopFlightRoutePrice.price,
			price_selected: DesktopFlightRoutePrice.price_selected,
			price__money: DesktopFlightRoutePrice.price__money,
			prices__wrp: DesktopFlightRoutePrice.prices__wrp,
			selectFrom_best: DesktopFlightRoutePrice.selectFrom_best,
			fare_family: DesktopFlightRoutePrice.fare_family,
			best: DesktopFlightRoutePrice.best,
			button: cn(BaseButtons.flight)
		},
		StopsInfoStyles: {
			stop: DesktopFlightRouteStopsInfo.stop
		}
	},
	DesktopFlight: {
		ModalContent: {
			content_wrapper: DesktopFlightModalContent.wrapper,
			buttons: DesktopFlightModalContent.buttons,
			fareGroup__button: DesktopFlightModalContent.fareGroup__button,
			fareGroup__button_active: DesktopFlightModalContent.fareGroup__button_active,
			fareGroup__button_business: DesktopFlightModalContent.fareGroup__button_business,
			total_time: cn(TransferInfo.transfer, TransferInfo.transferLayover),
			compareFaresLink_icon: DesktopFlightModalContent.compareFaresLink_icon,
			compareFaresLink: DesktopFlightModalContent.compareFaresLink,
			slider__wrp: DesktopFlightModalContent.slider__wrp,
			fareGroup__slide: DesktopFlightModalContent.fareGroup__slide,
			scroll_up: DesktopFlightModalContent.scroll_up,
			mobileTabs: DesktopFlightModalContent.mobileTabs,
			pagination: DesktopFlightModalContent.pagination
		},
		FlightInfoSegment: {
			card: DesktopFlightInfoSegment.card
		},
		Location: {
			time: DesktopFlightLocation.time,
			time_iata: DesktopFlightLocation.time_iata,
			city: DesktopFlightLocation.city,
			date: DesktopFlightLocation.date,
			date_icon: DesktopFlightLocation.date_icon,
			airport: DesktopFlightLocation.airport,
			terminal: DesktopFlightLocation.terminal,
			terminal_iata: DesktopFlightLocation.terminal_iata,
			isMobile: DesktopFlightLocation.isMobile
		},
		SelectedFareGroup: {
			button: DesktopFlightSelectedFareGroup.button,
			fareGroup_white: DesktopFlightSelectedFareGroup.fareGroup_white,
			keyFeature_paid: DesktopFlightSelectedFareGroup.keyFeature_paid,
			keyFeature__icon: DesktopFlightSelectedFareGroup.keyFeature__icon,
			keyFeature__value: DesktopFlightSelectedFareGroup.keyFeature__value
		},
		DesktopFlightModalHeader: {
			title: DesktopFlightModalHeader.title
		}
	},
	FlightCard: {
		FlightCard: {
			airline: FlightCard.airline,
			airline__number: FlightCard.airline__number,
			airline__name: FlightCard.airline__name,
			aircraft__name_active: FlightCard.aircraft__name_active
		}
	},
	CompareFares: {
		CompareFares: {
			mobile: CompareFares.mobile,
			selectedFare: CompareFares.selectedFare,
			compareFares: CompareFares.compareFares,
			slider_withoutImages: CompareFares.slider_withoutImages,
			groupTitle: CompareFares.groupTitle,
			tableRow: CompareFares.tableRow,
			fareHeadingItem: CompareFares.fareHeadingItem,
			fareHeadingItem_isKey: CompareFares.fareHeadingItem_isKey,
			fareHeadingItem_isFirstClass: CompareFares.fareHeadingItem_isFirstClass,
			fareHeadingItem__title: CompareFares.fareHeadingItem__title,
			col: CompareFares.col,
			cellContent_fullDescr: CompareFares.cellContent__full
		}
	},
	FareConditions: {
		FareConditions: {
			paperRoot: Results.fareConditions__paperRoot
		}
	},
	FareLock: {
		DescriptionBlock: {
			root: FareLockDescription.root
		}
	},
	MobileSegmentInfo: {
		MobileSegmentFlat: {
			image: MobileSegmentInfo.image
		}
	},
	AircraftPopup: {
		AircraftPopup: {
			close: AircraftPopup.close
		}
	},
	MobileFlight: {
		FlightStyles: {
			selectedFare__priceWrapper: MobileFlight.selectedFare__priceWrapper,
			price: cn(MobileFlight.price, BaseButtons.flight),
			price__text: MobileFlight.price__text,
			price__money: MobileFlight.price__money
		}
	},
	SeatMap: {
		ComponentStyles: {
			helpers: SeatMapComponent.helpers,
			header_fixed: SeatMapComponent.header_fixed,
			passengers_container: SeatMapComponent.passengers_container
		},
		AirplaneStyles: {
			airplane__amenities: SeatMapAirplane.airplane__amenities,
			airplane__info_wrapper: SeatMapAirplane.airplane__info_wrapper,
			airplane__name: SeatMapAirplane.airplane__name,
			airplane__info: SeatMapAirplane.airplane__info,
			details: SeatMapAirplane.details,
			seatsDetails: SeatMapAirplane.seatsDetails,
			segment: SeatMapAirplane.segment,
			airplane: SeatMapAirplane.airplane
		},
		SeatStyles: {
			number: Seat.number,
			seat: Seat.seat,
			seat_occupied: Seat.seat_occupied,
			seat_confirmed: Seat.seat_confirmed,
			seat_preferred: Seat.seat_preferred,
			seat_business: Seat.seat_business,
			seat_recommend: Seat.seat_recommend,
			seat_extended: Seat.seat_extended,
			seat_unrecline: Seat.seat_unrecline,
			seat_unavailable: Seat.seat_unavailable,
			seatPrice: Seat.seatPrice
		},
		Passenger: {
			item: SeatMapPassenger.item,
			item_active: SeatMapPassenger.item_active,
			avatar: SeatMapPassenger.avatar,
			select: SeatMapPassenger.select,
			money: SeatMapPassenger.money,
			clear: SeatMapPassenger.clear,
			passengerName: SeatMapPassenger.passengerName,
			item_recommend: SeatMapPassenger.item_recommend
		},
		SeatMapDisclaimerStyles: {
			disclaimer__wrp: SeatMapDisclaimer.disclaimer__wrp
		},
		SeatsInfoStyles: {
			freeSeat__container: SeatsInfo.freeSeat__container,
			price: SeatsInfo.price,
			price__wrapper: SeatsInfo.price__wrapper,
			seat: SeatsInfo.seat,
			seat_extended: SeatsInfo.seat_extended,
			title: SeatsInfo.title
		},
		SeatTooltipStyles: {
			popper: SeatTooltip.tooltip_popper,
			tooltip: SeatTooltip.tooltip,
			info: SeatTooltip.info,
			number: SeatTooltip.number,
			details: SeatTooltip.details,
			tooltip_withInfo: SeatTooltip.tooltip_withInfo,
			details__seatName: SeatTooltip.details__seatName,
			details__price: SeatTooltip.details__price
		},
		SeatMapStyles: {
			row__serviceHeader__wrapper: SeatMap.row__serviceHeader__wrapper,
			row__serviceHeader: SeatMap.row__serviceHeader,
			row__serviceHeader_preferred: SeatMap.row__serviceHeader_preferred,
			row__serviceHeader_comfort: SeatMap.row__serviceHeader_comfort
		},
		PassengersStyles: {
			recommend: SeatMapPassengers.recommend,
			recommend__icon: SeatMapPassengers.recommend__icon,
			slider: SeatMapPassengers.slider
		},
		DoubleSeat: {
			container: DoubleSeat.container
		}
	},
	Amenities: {
		Amenities: {
			amenities__item: Amenities.amenities__item
		}
	},
	Disclaimer: {
		DisclaimerStyles: {
			disclaimer__icon: SeatMapDisclaimer.disclaimer__icon
		}
	},
	AdditionalServiceBanner: {
		AdditionalServiceBannerStyles: {
			wrapper: AdditionalServiceBanner.wrapper,
			baggageBanner: AdditionalServiceBanner.baggageBanner,
			text: AdditionalServiceBanner.text,
			image: AdditionalServiceBanner.image,
			additional: AdditionalServiceBanner.additional,
			disclaimer: AdditionalServiceBanner.disclaimer
		}
	},

	Baggage: {
		Baggage: {
			name: BaggagePage.baggageName,
			size: BaggagePage.baggageSize
		},
		BaggageIcon: {
			root: BaggagePage.baggageIcon__root
		}
	},
	UpgradeBaggageDialog: {
		MobileBaggageSelector: {
			container: BaggagePage.dialog__container,
			selector: BaggagePage.dialog__selector,
			selected: BaggagePage.dialog__selector_selected
		},
		UpgradeBaggageDialog: {
			modalHeader: BaggagePage.dialog__header
		},
		BaggageDialogHeader: {
			baggage_wrapper: BaggagePage.dialogHeader__baggage_wrapper,
			price_wrapper: BaggagePage.dialogHeader__price_wrapper,
			description: BaggagePage.dialogHeader__description,
			price_label: BaggagePage.dialogHeader__price_label,
			category_title: BaggagePage.dialogHeader__category_title
		},
		BaggageSegment: {
			root: BaggagePage.dialogSegment__root,
			name: BaggagePage.dialogSegment__name,
			name_withPrices: BaggagePage.dialogSegment__name_withPrices,
			price: BaggagePage.dialogSegment__price
		},
		BaggagePassenger: {
			number: BaggagePage.dialogPassenger__number,
			name: BaggagePage.dialogPassenger__name,
			name_wrapper: BaggagePage.dialogpassenger__name_wrapper,
			row: BaggagePage.dialogpassenger__row,
			baggages: BaggagePage.dialogpassenger__baggages
		},
		BaggageFooter: {
			price_wrapper: BaggagePage.dialogFooter__price_wrapper,
			clear: BaggagePage.dialogFooter__clear,
			confirm_btn: BaseButtons.smallPrimary,
			cancel_btn: BaseButtons.smallSecondary
		},
		HeaderEquipmentItem: {
			wrapper: BaggagePage.equipment__itemWrapper,
			active: BaggagePage.equipment__itemWrapper_active
		}
	},
	BaggageCounter: {
		BaggageCounter: {
			value: BaggagePage.counter__value
		}
	},
	BaggagePage: {
		BaggagePage: {
			baggage: BaggagePage.baggage,
			newBaggage: BaggagePage.newBaggage,
			items: BaggagePage.items,
			equipment_baggage: BaggagePage.equipment_baggage
		}
	},
	BaggageList: {
		BaggageList: {
			baggage_direction: BaggagePage.baggage_direction,
			baggage_count: BaggagePage.baggage_count
		}
	},
	IncludedBaggage: {
		IncludedBaggage: {
			header: BaggagePage.subheader
		}
	},
	AdditionalBaggage: {
		AdditionalBaggage: {
			header: BaggagePage.subheader,
			promo_message: BaggagePage.promo_message
		}
	},
	OverweightBaggage: {
		OverweightBaggage: {}
	},
	BaggageCard: {
		BaggageCard: {
			wrapper: BaggagePage.cardWrapper,
			header: BaggagePage.cardHeader,
			title: BaggagePage.subheader,
			description: BaggagePage.cardDescription,
			icon: BaggagePage.cardIcon,
			price: BaggagePage.totalPrice,
			button: BaseButtons.optionEdit
		}
	},
	BaggageTotalPriceBlock: {
		BaggageTotalPriceBlock: {
			price: BaggagePage.totalPrice,
			control: BaseButtons.optionEdit,
			control__edit: BaseButtons.optionEdit
		}
	},
	Checkin: {
		Conditions: {
			container: Checkin.login__container,
			title: Checkin.login__title,
			icon: Checkin.login__icon,
			conditions: Checkin.login__conditions
		}
	},
	SelectedPassenger: {
		SelectedPassenger: { passengerContent: Checkin.passenger__content }
	},
	RegisteredPassenger: {
		RegisteredPassenger: {
			footer: Checkin.registeredPassenger__footer
		}
	},
	StatusMessage: {
		StatusMessage: {
			statusMessage_success: Checkin.statusMessage__success,
			statusMessage__title: Checkin.statusMessage__title
		}
	},
	Exchange: {
		Inner: {
			header__text: ExchangeInner.header__text,
			close: ExchangeInner.close,
			message_restrictionsRejectSeats: ExchangeInner.message_restrictionsRejectSeats
		},
		CommonSelect: {
			header: ExchangeCommonSelect.header,
			icon: ExchangeCommonSelect.icon,
			button: ExchangeCommonSelect.button,
			back: ExchangeCommonSelect.button
		},
		Choice: {
			label: ExchangeChoice.label,
			label_selected: ExchangeChoice.label_selected,
			labelInner: ExchangeChoice.labelInner,
			container: ExchangeChoice.container,
			button: ExchangeChoice.button
		},
		Chip: {
			close: ExchangeChip.close,
			chip: ExchangeChip.chip
		},
		SearchFlights: {
			header__cities: ExchangeSearchFlights.header__cities,
			leg: ExchangeSearchFlights.leg
		},
		SelectedFlights: {
			price: ExchangeSelectedFlights.price,
			charge: ExchangeSelectedFlights.charge,
			total: ExchangeSelectedFlights.total,
			header__name: ExchangeSelectedFlights.header__name,
			taxesTooltip: ExchangeSelectedFlights.taxesTooltip
		},
		CreateRequest: {
			submit: ExchangeCreateRequest.submit,
			controls: ExchangeCreateRequest.controls
		},
		RequestControls: {
			refuse: ExchangeRequestControls.refuse,
			dialog__deleteIcon: ExchangeRequestControls.dialog__deleteIcon
		}
	},
	Refund: {
		Breadcrumbs: {
			breadcrumb: RefundBreadcrumbs.breadcrumb,
			close: RefundBreadcrumbs.close
		},
		Wrapper: {
			title: RefundWrapper.title,
			close__text: RefundWrapper.close__text,
			header_wrapper: RefundWrapper.header_wrapper
		},
		StepTitle: {
			text: RefundStepTitle.text,
			step: RefundStepTitle.step
		},
		ReasonForm: {
			groupTitle: RefundReasonForm.groupTitle
		},
		StepsButtons: {
			button: RefundStepsButtons.button
		},
		Status: {
			waiting: RefundStatus.waiting
		},
		Price: {
			totalTitle: RefundPrice.totalTitle,
			total: RefundPrice.total,
			money: RefundPrice.money,
			row: RefundPrice.row
		},
		RefundInfoModal: {
			icon: RefundInfoModal.icon
		}
	},
	FullscreenDialog: {
		FullscreenDialog: {
			close__icon: RefundWrapper.close__icon
		}
	},
	DesktopSummaryFlight: {
		SummaryFlight: {
			features__items: Passengers.summaryFlight__features__items
		},
		Header: {
			header__cell: DesktopSummaryFlight.header__cell,
			title: Passengers.titleSecondary,
			header__icon: DesktopSummaryFlight.header__icon,
			travelTime: DesktopSummaryFlight.travelTime,
			fareGroup__name: DesktopSummaryFlight.fareGroup__name,
			arrowIcon: DesktopSummaryFlight.arrowIcon,
			price: Passengers.titleBig
		}
	},
	MobileStepbar: {
		MobileStepbarStyles: {
			stepbar: MobileStepbar.stepbar
		},
		StepbarHeader: {
			header: MobileStepbarHeader.header,
			expand: MobileStepbarHeader.expand
		}
	},
	Contacts: {
		ContactsStyles: {
			description__header: cn(Passengers.title, Passengers.description__header),
			description__content: cn(Passengers.text, Passengers.description__content),
			description__text: Passengers.description__text,
			checkbox__label: Passengers.checkbox__label,
			footer__text: Passengers.textAccented,
			header: Passengers.contactsHeader,
			checkbox: Passengers.contactsCheckbox,
			form: Passengers.contactsForm,
			description: Passengers.contactsDescription
		}
	},
	DesktopFlightInfo: {
		Point: {
			point: Passengers.textSmallAccented,
			terminal: Passengers.textSmall
		},
		Segment: {
			duration: Passengers.textSmall,
			airline: Passengers.textSmall
		}
	},
	PassengerForm: {
		Header: {
			header: Passengers.passengerForm__header,
			payload: Passengers.passengerForm__payload,
			passengerName: Passengers.passengerForm__passengerName
		},
		LoyaltyGroup: {
			loyalty_switch: Passengers.passengerForm__loyalty_switch
		}
	},
	PaymentForm: {
		PaymentForm: {
			applepay: PaymentForm.applepay,
			googlepay: PaymentForm.googlepay
		}
	},
	Entities: {
		Fare: {
			TaxesTooltip: {
				root: TaxesTooltip.root
			}
		}
	}
};

export default theme;
